import {styled} from '@mui/material/styles'
import ErrorIcon from '@mui/icons-material/Error'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import DialogContent from '@mui/material/DialogContent'
import {Hidden} from '@mui/material'

export const StyledDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasPadding' && prop !== 'textBold'
})(({theme, hasPadding, textBold}) => ({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  fontWeight: hasPadding && textBold ? 'bold' : '',
  color: theme.palette.hpBlack,
  padding: hasPadding ? theme.spacing(1) : ''
}))

export const StyledErrorIcon = styled(ErrorIcon)(({theme}) => ({
  color: theme.palette.primary.dark,
  fontSize: theme.typography.h4.fontSize,
  pointerEvents: 'none'
}))

export const StyledButton = styled(Button, {shouldForwardProp: (prop) => prop !== 'isCancelButton'})(
  ({theme, isCancelButton}) => ({
    color: isCancelButton ? theme.palette.primary.dark : theme.palette.hpWhite,
    textTransform: 'none',
    backgroundColor: isCancelButton ? theme.palette.hpWhite : theme.palette.primary.main,
    borderRadius: isCancelButton ? '' : theme.spacing(0.5),
    width: isCancelButton ? '211px' : 'auto',
    '&:hover': {
      backgroundColor: isCancelButton ? theme.palette.hpWhite : theme.palette.hpPrimaryDark
    }
  })
)

export const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize, // 14px
  color: theme.palette.hpBlack,
  textAlign: 'center',
  lineHeight: theme.typography.h1.lineHeight, // 16px
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2)
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  padding: theme.spacing(0),
  marginRight: theme.spacing(3),
  float: 'right'
}))

export const StyledDialogContent = styled(DialogContent)(({theme}) => ({
  paddingBottom: theme.spacing(4.5),
  paddingTop: theme.spacing(2),
  paddingLeft: 0,
  paddingRight: 0,
  overflow: Hidden
}))

export const StyledSectionDividerLine = styled('div')(({theme}) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  width: '100%',
  border: `1px solid ${theme.palette.grey[200]}`
}))
